export class GiveAwardModel {
    userName: string = "";
    iconId: number = 0;
    expirationDate: string = "";
}
